import { jsx as t } from "react/jsx-runtime";
import e from "./index23.js";
const r = (o) => typeof o != "string" ? o : typeof window > "u" ? /* @__PURE__ */ t("span", { dangerouslySetInnerHTML: { __html: o } }) : e(o);
export {
  r as safeHtmlParse
};
